import * as Actions from 'Actions/shoppingCartAction';
import * as TransactionActions from 'Actions/checkoutTransactionAction';
import {sendGoogleAnalyticsEvent} from 'Actions/googleAnalyticsAction';
import * as ActionTypes from 'Types/ShoppingCartActionTypes';

const ShoppingCartApiMiddlewareAction = (action, dispatch, getState) => {
    switch (action.type) {
        case ActionTypes.REQUEST_SHOPPINGCARTPAGE:
            api.getShoppingCartPage(action, dispatch, getState);
            break;
        case ActionTypes.REQUEST_UPDATE_SHOPPINGCART_PRODUCTS:
            api.updateShoppingCartProducts(action, dispatch, getState);
            break;
        case ActionTypes.REQUEST_MOVE_BUILD_LIST_ITEM_TO_CART:
            api.moveBuildlistItemToCart(action, dispatch, getState);
	        break;        
        case ActionTypes.REQUEST_MOVE_CART_ITEM_TO_BUILD_LIST:
            api.moveCartItemToBuildlist(action, dispatch, getState);
	        break;
        case ActionTypes.REQUEST_REMOVE_BUILD_LIST_ITEM:
            api.removeBuildlistItem(action, dispatch, getState);
            break;
        case ActionTypes.REQUEST_MOVE_SAVED_FOR_LATER_PART_TO_BUILD_LIST:
            api.moveSavedForLaterProductToBuildList(action, dispatch, getState);
            break;
        case ActionTypes.RECEIVE_SHOPPINGCARTPAGE:
        case ActionTypes.RECEIVE_UPDATE_SHOPPINGCART_PRODUCTS:
        case ActionTypes.RECEIVE_MOVE_BUILD_LIST_ITEM_TO_CART:
        case ActionTypes.RECEIVE_MOVE_CART_ITEM_TO_BUILD_LIST:
        case ActionTypes.RECEIVE_REMOVE_BUILD_LIST_ITEM:
            var { featureFlagContainer, shoppingCart } = getState()
            if (featureFlagContainer.isHeaderRedesignEnabled) {
                window.SMI.updateDs9CartContext(shoppingCart.itemCount)
            }
            break;
        default:
            break;
    }
}

// API wrapper to avoid naming collision
var api = {};

var api = {
    getShoppingCartPage: (action, dispatch, getState) => {
        return fetch("/data/shoppingcart/getshoppingcart",
                {
                    credentials: 'include'
                })
            .then(response => response.json())
            .then(json => {
                if (!json.status.success) {
                    //.handleErrors(json.status, true, dispatch)
                    console.log("bad things are happening on the cart page with the request")
                }
                dispatch(Actions.receiveShoppingCartPage(json))
            })
            .catch(error => {
                console.error('fetchShoppingCartPage', error)
                dispatch(TransactionActions.disableLoader())
                alert('Sorry, an error occurred. Please try again or contact Customer Service at 800.979.0122')
            })
    },
    updateShoppingCartProducts: (action, dispatch, getState) => {
        let data = {
            addComponentCartItems: action.payload.skusToAdd,
            removeComponentCartItems: action.payload.skusToRemove
        }
        return fetch("/data/shoppingcart/updateshoppingcart",
                {
                    method: "POST",
                    body: JSON.stringify(data),
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    credentials: 'include'
                })
            .then(response => response.json())
            .then(json => {
                if (!json.status.success) {
                    dispatch(TransactionActions.disableLoader())
                    alert("An error occurred updating the shopping cart products. Please try again.")
                    console.error("an error occurred updating the shopping cart products.")
                } else {
                    // This is to support updating the qty in the legacy header.
                    // When we replace the header, remove this code!!
                    SMI.Header.clearCacheData();
                    SMI.Header.updateHeaderInformation(true);

                    dispatch(Actions.receiveUpdateShoppingCartProducts(json))
                    dispatch(Actions.hideShippingEstimate(true))
                }
            })
            .catch(error => {
                dispatch(TransactionActions.disableLoader())
                console.error('fetchShoppingCartPage', error)
                alert('Sorry, an error occurred. Please try again or contact Customer Service at 800.979.0122')
            })
    },
    moveBuildlistItemToCart: (action, dispatch, getState) => {

        if(!navigator.globalPrivacyControl && !document.cookie.includes('EnableGpc=')) {
            dispatch(sendGoogleAnalyticsEvent('Cart', 'Moved Wish List Item to Cart', action.payload.skuNumber))
        }

        var brData = {
            prod_id: action.payload.productDetails.skuBase,
            sku: action.payload.productDetails.skuVariant,
            eventType: 'addToCart'
        }

        window.fireSearchTrackingEvent(brData)
         
        let data = {
            buildlistItemId: action.payload.buildlistItemId,
            buildlistId: getState().shoppingCart.buildlistId
        }
        return fetch("/data/shoppingcart/movebuildlistitemtocart",
                {
                    method: "POST",
                    body: JSON.stringify(data),
                    headers: {
                        'Content-Type': 'application/json' 
                    },
                    credentials: 'include'
                })
            .then(response => response.json())
            .then(json => {
                if (!json.status.success) {
                    dispatch(TransactionActions.disableLoader())
                    alert("An error occurred updating the shopping cart products. Please try again.")
                    console.error("an error occurred updating the shopping cart products.")
                } else {
                    // This is to support updating the qty in the legacy header.
                    // When we replace the header, remove this code!!
                    SMI.Header.clearCacheData();
                    SMI.Header.updateHeaderInformation(true);

                    dispatch(Actions.receiveMoveBuildlistItemToCart(json))
                    dispatch(Actions.hideShippingEstimate(true))

                    SMI.updateDs9ListContext()
                }
            })
            .catch(error => {
                dispatch(TransactionActions.disableLoader())
                console.error('move buildlist item to cart', error)
                alert('Sorry, an error occurred. Please try again or contact Customer Service at 800.979.0122')
            })
    },
    moveCartItemToBuildlist: (action, dispatch, getState) => {

        if(!navigator.globalPrivacyControl && !document.cookie.includes('EnableGpc=')) {
            dispatch(sendGoogleAnalyticsEvent('Cart', 'Moved Cart Item to Saved For Later', action.payload.skuNumber))
        }

        let data = {
            cartItemId: action.payload.cartItemId
        }
        return fetch("/data/shoppingcart/movecartitemtobuildlist",
                {
                    method: "POST",
                    body: JSON.stringify(data),
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    credentials: 'include'
                })
            .then(response => response.json())
            .then(json => {
                if (!json.status.success) {
                    dispatch(TransactionActions.disableLoader())
                    alert("An error occurred updating the shopping cart products. Please try again.")
                    console.error("an error occurred updating the shopping cart products.")
                } else {
                    // This is to support updating the qty in the legacy header.
                    // When we replace the header, remove this code!!
                    SMI.Header.clearCacheData();
                    SMI.Header.updateHeaderInformation(true);

                    dispatch(Actions.receiveMoveCartItemToBuildlist(json))
                    dispatch(Actions.hideShippingEstimate(true))

                    SMI.updateDs9ListContext()
                }
            })
            .catch(error => {
                dispatch(TransactionActions.disableLoader())
                console.error('move cart item to buildlist', error)
                alert('Sorry, an error occurred. Please try again or contact Customer Service at 800.979.0122')
            })
    },
    moveSavedForLaterProductToBuildList: (action, dispatch, getState) => {

        if(!navigator.globalPrivacyControl && !document.cookie.includes('EnableGpc=')) {
            dispatch(sendGoogleAnalyticsEvent('Cart', 'Moved Saved For Later Item to Wish List', "Moved Saved For Later Item to Wish List"))
        }

        const { shoppingCart, userProfile } = getState();
        const savedForLater = shoppingCart.savedForLaterProducts
        let variables = {
            webUserGuid: userProfile.userGuid,
            listIdFrom: action.payload.fromListId,
            listIdTo: action.payload.toListId,
            itemId: action.payload.itemId,
            includeSavedForLater: true
        }

        const query = `
        mutation MoveItemBetweenLists($webUserGuid: String!, $listIdFrom: Int!, $listIdTo: Int!, $itemId: Int!, $includeSavedForLater: Boolean) {
          moveItemBetweenLists(
            webUserGuid: $webUserGuid
            listIdFrom: $listIdFrom
            listIdTo:$listIdTo
            itemId: $itemId
            includeSavedForLater: $includeSavedForLater
          ) {
            success
            message
            lists {
              listName
              id
              productCount
              customerProjectId
              ordinality
              shareUrl
              totalPrice
              products {
                listProductId
                comment
                quantity
                skuBaseNumber
                sku
                productUrl
                title
                imageUrl
                availability
                rating{
                  count
                  aggregate
                }
                strikeThroughPrice
                strikeThroughPriceString
                price
                priceString
                components{
                  listProductId
                comment
                quantity
                sku
                productUrl
                title
                imageUrl
                availability
                rating{
                  count
                  aggregate
                }
                }
              }
            }
            listWithProductsCount
          }
        }`

        dispatch(TransactionActions.enableLoader())

        let response =  fetch(shoppingCart.checkoutUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: query,
                variables: variables
            }),
            credentials: 'include'
        }).then((response) => {
            return response.json()
        }).then((response) => {
            if (response.errors) {
                response.errors.forEach((x) => console.error(x))
                dispatch(TransactionActions.disableLoader())
            }
            else if (response.data?.moveItemBetweenLists?.success) {
                const savedForLaterList = response.data.moveItemBetweenLists.lists?.find(x => x.listName === "Saved For Later")
                const responseProducts = savedForLaterList?.products ?? []

                const responseProductIds = responseProducts.map(product => product.listProductId)

                const savedForLaterProducts = savedForLater.filter(product => responseProductIds.includes(product.cartProductId))

                dispatch(Actions.receiveMoveSavedForLaterPartToBuildList(savedForLaterProducts))

                if (typeof window !== 'undefined') {
                    window.localStorage.removeItem("listv1")
                }
                dispatch(TransactionActions.disableLoader())
            } else {
                dispatch(TransactionActions.disableLoader())
            }
        }).catch((error) => {
            console.error('Failed Request', error)
            dispatch(TransactionActions.disableLoader())
        })


    },
    removeBuildlistItem: (action, dispatch, getState) => {
        let data = {
            buildlistItemIds: action.payload.buildlistItemIds
        }
        return fetch("/data/shoppingcart/removeitemfrombuildlist",
                {
                    method: "POST",
                    body: JSON.stringify(data),
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    credentials: 'include'
                })
            .then(response => response.json())
            .then(json => {
                if (!json.status.success) {
                    dispatch(TransactionActions.disableLoader())
                    alert("An error occurred removing the product from Saved For Later. Please try again.")
                    console.error("n error occurred updating the shopping cart products.")
                } else {
                    // This is to support updating the qty in the legacy header.
                    // When we replace the header, remove this code!!
                    SMI.Header.clearCacheData();
                    SMI.Header.updateHeaderInformation(true);

                    dispatch(Actions.receiveRemoveItemFromBuildlist(json))
                    dispatch(Actions.hideShippingEstimate(true))

                    SMI.updateDs9ListContext()
                }
            })
            .catch(error => {
                dispatch(TransactionActions.disableLoader())
                console.error('remove item from buildlist', error)
                alert('Sorry, an error occurred. Please try again or contact Customer Service at 800.979.0122')
            })
    }
}
export default ShoppingCartApiMiddlewareAction



